import { createAction, props } from '@ngrx/store';

import { PartialToast, Toast } from '@stylehaven/components';

export const AddToast = createAction('[Shared Toast] Add', props<{ toast: Toast }>());
export const DeleteToast = createAction('[Shared Toast] Delete', props<{ id: number }>());
export const UpdateToast = createAction('[Shared Toast] Update', props<{ id: number; toast: PartialToast }>());
export const UpsertToast = createAction('[Shared Toast] Upsert', props<{ toast: Toast }>());
export const UnsetToasts = createAction('[Shared Toast] Unset toasts');
